import React, { useState } from 'react';
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
  Typography
} from '@mui/material';
import {
  AccountCircleOutlined,
  LogoutOutlined,
  SettingsOutlined
} from '@mui/icons-material';

const UserProfileMenu = ({ onLogout }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    onLogout?.();
  };

  return (
    <Box>
        <IconButton
          aria-controls={open ? 'user-profile-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true"
          onClick={handleOpen}
          sx={{ p: 0 }}>
          <Avatar
            sx={{
              width: 36,
              height: 36,
              bgcolor: '#AE8648',
              color: '#FFFFFF',
              fontSize: 13,
              fontWeight: 600
            }}>
            OR
          </Avatar>
        </IconButton>

      <Menu
        id="user-profile-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 3,
            sx: {
              width: 220,
              mt: 1.5,
              borderRadius: '6px',
              overflow: 'visible',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0
              }
            }
          }
        }}
        transformOrigin={{
          horizontal: 'right',
          vertical: 'top'
        }}
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'bottom'
        }}>
        <Box sx={{ px: 2, py: 1.5 }}>
          <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
            Olivia Robert
          </Typography>

          <Typography
            sx={{
              mt: 0.25,
              color: 'text.secondary',
              fontSize: 12
            }}>
            olivia.robert@example.com
          </Typography>
        </Box>

        <Divider />

        <MenuItem
          onClick={handleLogout}
          sx={{
            py: 1,
            color: '#D32F2F',
            gap:0
          }}>
          <ListItemIcon sx={{ color: 'inherit',minWidth:'22px !important' }}>
            <LogoutOutlined fontSize="small" sx />
          </ListItemIcon>
          Sign out
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default UserProfileMenu;